import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {Alert, Button, Empty, Icon, Popconfirm, Spin, Table, Input, Row, Col} from 'antd';
import { grammarNumbers } from '../../Utils';
import AnimateEnter from '../AnimateEnter';
import { CAMPAIGNS_RESOURCE_NAME } from '../../config/constants';
import { _callResource } from '../../context/_callResource';
import { withCancellablePromise } from '../../hocs/withCancellablePromise';
import { _allCampaignColumns } from './columns/allCampaignsColumns';
import MESSAGES from '../../locale/messages';
import TEXTS from '../../locale/texts';

class AllCampaigns extends Component {
  state = {
    selectedRows: [],
    pageSize: 10,
    isMounted: true,
    filter: '',
    copyCampaignIsLoaded: false,

    // campaigns resource
    campaignsData: null,
    campaignsDataIsLoading: true,
    campaignsDataError: null,

    // campaigns export resource
    campaignsExportIsLoading: false,
    campaignsExportError: false,

    // campaigns delete resource
    campaignsDeleteIsLoading: false,
    campaignsDeleteError: false,

    deleteOneOfCampaignsIsLoading: false,
    deleteOneOfCampaignsError: null,

    activeCampaignId: null
  };

  columns = _allCampaignColumns.bind(this);
  callResource = _callResource.bind(this);

  rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      this.setState({ selectedRows });
    }
  };

  goToNewCampaign = () => {
    this.props.history.push('/sms-campaigns/create');
  };

  componentDidMount() {
    this.getAllCampaigns();
  }

  getAllCampaigns = () => {
    const { promiseCancelToken } = this.props;
    window.scrollTo(0 ,86);
    this.setState({ selectedRows: [] });
    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'get',
      promiseCancelToken
    });
  };

  exportMessage = ({ id, name, exportType }) => {
    const { promiseCancelToken, lang } = this.props;
    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'download',
      apiCallParams: { id, name, exportType },
      promiseCancelToken,
      notification: {
        text: MESSAGES.campaignNameIsExported(name)[lang]
      }
    });
  };

  mobileOperatorsReport = ({ id, name, exportType }) => {
    const { promiseCancelToken, lang } = this.props;
    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'download',
      apiCallParams: { id, name, exportType },
      promiseCancelToken,
      notification: {
        text: name ? MESSAGES.mobileOperatorsReportIsExported(name)[lang] : TEXTS.mobileOperatorsReportIsExported[lang]
      }
    });
  };

  deleteOneOfCampaigns = ({ id, name }) => {
    const { promiseCancelToken, lang } = this.props;
    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'deleteOneOf',
      apiCallParams: { id },
      promiseCancelToken,
      notification: {
        text: MESSAGES.campaignDraftNameIsDeleted(name)[lang]
      },
      onSuccess: this.getAllCampaigns
    });
  };

  deleteDraftCampaign = () => {
    const { selectedRows } = this.state;
    const { promiseCancelToken, addNotification, lang } = this.props;
    const ids = selectedRows.map(({ id }) => id);
    const n = ids.length;

    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'delete',
      apiCallParams: { ids },
      promiseCancelToken,
      onSuccess: () => {
        const msg = grammarNumbers(n, [
          TEXTS['1CampaignIsDeleted'][lang],
          TEXTS['2CampaignsAreDeleted'][lang],
          TEXTS['5CampaignsAreDeleted'][lang]
        ]);
        addNotification(`${n} ${msg}`);
        this.getAllCampaigns();
      }
    });
  };

  handleChangeFilter = ({ target: { value: filter } }) => {
    this.setState({ filter });
  };

  editCampaign = (_idDynamic) => {
    const { promiseCancelToken, history } = this.props;
    const { selectedRows } = this.state;

    this.setState({ copyCampaignIsLoaded: true });
    const id = _idDynamic || (selectedRows[0] && selectedRows[0].id);

    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'getOneOf',
      apiCallParams: { id },
      showLoading: false,
      promiseCancelToken,
      onSuccess: ({ data: campaign }) => {
        console.log('ERERERER');
        history.push({
          pathname: `/sms-campaigns/edit/${id}`,
          state: campaign
        });
      }
    });
  };

  copyCampaign = async (_idDynamic) => {
    const { history, promiseCancelToken } = this.props;
    const { selectedRows } = this.state;

    this.setState({ copyCampaignIsLoaded: true });
    const id = _idDynamic || (selectedRows[0] && selectedRows[0].id);

    this.callResource({
      resourceName: CAMPAIGNS_RESOURCE_NAME,
      apiClassName: 'campaigns',
      action: 'getOneOf',
      apiCallParams: { id },
      showLoading: false,
      promiseCancelToken,
      onSuccess: ({ data: campaign }) => {
        history.push({
          pathname: '/sms-campaigns/create',
          state: campaign
        });
      }
    });
  };

  renderData = () => {
    const {
      campaignsData,
      isMounted,
      pageSize,
      campaignsDataError,
      filter,
      activeItemId
    } = this.state;
    const { lang, history } = this.props;

    if (campaignsDataError) {
      const { errorTitle, errorMessage } = campaignsDataError;
      return (
        <Alert
          message={errorTitle}
          description={errorMessage}
          type="error"
        />
      );
    }

    const _campaigns = campaignsData && campaignsData.items;

    const campaigns = (_campaigns && filter) ? _campaigns.filter(({ name, smsBody }) => {
      const matcher = new RegExp(`${filter}`, 'ig');
      return smsBody.match(matcher) || name.match(matcher);
    }) : _campaigns;

    const columns = this.columns(activeItemId, history, lang);

    return (
      <AnimateEnter paginationAnimate={{ isMounted }}>
        <Table
          columns={columns}
          dataSource={campaigns}
          rowSelection={this.rowSelection}
          rowKey={({ id }) => id}
          pagination={{
            pageSize: pageSize,
            hideOnSinglePage: true,
            size: 'large',
            onChange: (page) => {
              window.scrollTo(0 ,86);
              this.setState({
                currentPage: page,
                isMounted: false
              });
              setTimeout(() => {
                this.setState({
                  isMounted: true
                });
              }, 0);
            }
          }}
        />
      </AnimateEnter>
    );
  };

  render() {
    const { lang } = this.props;
    const {
      selectedRows,
      campaignsDeleteIsLoading,
      campaignsExportIsLoading,
      filter,
      copyCampaignIsLoaded,
      campaignsDataIsLoading
    } = this.state;

    const campaignsCanBeDeleted = selectedRows.length > 0
      && selectedRows.every(({ status }) => status === 'DRAFT');

    return (
      <div>
        <section className="submenu bg-white table-header">
          <Row gutter={16} type="flex" justify="space-between">
            <Col xs={24} sm={24} md={24} lg={16} xl={12} className="all-campaign-options d-flex">
              <Button
                  block
                  className="mr-3"
                  size="large"
                  icon="message"
                  onClick={this.goToNewCampaign}>
                {TEXTS.btnCreateCampaign[lang]}
              </Button>
              <Popconfirm
                  placement="bottom"
                  title={TEXTS.areYouSureToDeleteChosenCampaigns[lang]}
                  okText={TEXTS.yes[lang]}
                  cancelText={TEXTS.btnToCancel[lang]}
                  onConfirm={this.deleteDraftCampaign}
                  disabled={selectedRows.length <= 1 || campaignsDeleteIsLoading || !campaignsCanBeDeleted}
              >
                <Button
                  block
                  ghost={selectedRows.length > 1 && !campaignsDeleteIsLoading && campaignsCanBeDeleted}
                  type="danger"
                  size="large"
                  icon="delete"
                  loading={campaignsDeleteIsLoading}
                  disabled={selectedRows.length <= 1 || campaignsDeleteIsLoading || !campaignsCanBeDeleted}
                >
                  {TEXTS.btnDeleteDrafts[lang]}
                </Button>
              </Popconfirm>
            </Col>
            <Col xs={24} sm={24} md={24} lg={8} xl={10} xxl={7}>
              <Input prefix={<Icon type="search" style={{ color: 'rgba(0,0,0,.25)' }} />}
                allowClear
                size="large"
                value={filter}
                placeholder={TEXTS.searchCampaignPlaceholder[lang]}
                onChange={this.handleChangeFilter}
              />
            </Col>
          </Row>
        </section>
        <section className="all-campaigns">
          {campaignsDataIsLoading
            ? <Empty description={TEXTS.dataIsLoading[lang]}>
                <div style={{marginTop: 15, textAlign: 'center'}}>
                  <Spin spinning={true} />
                </div>
              </Empty>
            : this.renderData()}
        </section>
      </div>
    );
  }
}

export default withCancellablePromise(withRouter(AllCampaigns), 'getCampaigns');
